export { default, type TeamSectionProps, SECTION_ID as teamSectionId } from './TeamSection';
